































































































































# import settings from '@/settings'
import Menus from '@/components/menus'
import n from '@/utils/notifications'
import t from '@/utils/tools'
import q from '@/graphql/query'
import m from '@/graphql/mutation'
import _ from 'lodash'


export default {
    name: 'contact_details'

    components: { Menus }

    data: ()->
        errors: {}
        loading: true
        alert: false
        search1: ''
        search2: ''
        table1: true
        table2: false
        table3: false
        single_table_group: false
        save_dialog_visible: false
        pager_count: 5
        current_page: 1
        page_size: 10
        checkbox_selection: false
        group_selection: false
        multipleSelection: []
        emails:""
        app_users: []
        annuairegroupe:[]
        annuairetypegroupe:[]
        singlegroup:[]
        annuairegroupe_form: {
            uid:'',
            user_uid:'',
            type_uid:''
        }
        annuairetypegroupe_form:{
            uid:'',
            name:'',
            company_uid:@$store.getters.current_company.uid
            user_uid:@$store.state.user_datas.app_user.uid
        }

    computed:

        has_deletion_right: ()->
            if @uid == @$store.state.user_datas.app_user.uid
                return false
            return @has_access_right('annuairegroupe_self_delete')
        
        data_filtered: ()->
            self = @
            data = @app_users.filter (x) ->
                !self.search1 || x.user_info.lastname.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,"").includes(self.search1.toLowerCase()) || x.user_info.lastname.toLowerCase().includes(self.search1.toLowerCase())\
                || x.user_info.firstname.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,"").includes(self.search1.toLowerCase()) || x.user_info.firstname.toLowerCase().includes(self.search1.toLowerCase())\
                || x.user_info.phone.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,"").includes(self.search1.toLowerCase()) || x.user_info.phone.toLowerCase().includes(self.search1.toLowerCase())\
                || x.service_name.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,"").includes(self.search1.toLowerCase()) || x.service_name.toLowerCase().includes(self.search1.toLowerCase())\
                || x.job.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,"").includes(self.search1.toLowerCase()) || x.job.toLowerCase().includes(self.search1.toLowerCase())\
                || x.email.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,"").includes(self.search1.toLowerCase()) || x.email.toLowerCase().includes(self.search1.toLowerCase())
            return data
        
        data_filtered_annuaire: ()->
            self = @
            annuaire_array = self.data_single_annuaire_group
            test = self.app_users
            data = self.app_users.filter (x) ->
                !annuaire_array.some (y) ->
                    x.email == y.user.email &&\
                    (!self.search2 || x.user_info.lastname.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,"").includes(self.search2.toLowerCase()) || x.user_info.lastname.toLowerCase().includes(self.search2.toLowerCase())\
                    || x.user_info.firstname.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,"").includes(self.search2.toLowerCase()) || x.user_info.firstname.toLowerCase().includes(self.search2.toLowerCase())\
                    || x.job.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,"").includes(self.search2.toLowerCase()) || x.job.toLowerCase().includes(self.search2.toLowerCase())\
                    || x.email.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,"").includes(self.search2.toLowerCase()) || x.email.toLowerCase().includes(self.search2.toLowerCase()))
        data_filtered_annuaire_type: ()->
            self = @
            data = self.annuairetypegroupe.filter (x) ->
                !self.search2 || x.name.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,"").includes(self.search2.toLowerCase()) || x.name.toLowerCase().includes(self.search2.toLowerCase())
            return data
        data_paged: ()->
            data = @data_filtered.slice(((@current_page - 1) * @page_size), (@page_size * @current_page))
            return data
        data_paged_annuaire: ()->
            self = @
            data = self.data_filtered_annuaire.slice(((self.current_page - 1) * self.page_size), (self.page_size * self.current_page))
            return data
        data_single_annuaire_group: ()->
            self = @
            data = self.annuairegroupe.filter (x) ->
                x.type.uid == self.singlegroup.uid &&\
                (!self.search2 || x.user.user_info.lastname.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,"").includes(self.search2.toLowerCase()) || x.user.user_info.lastname.toLowerCase().includes(self.search2.toLowerCase())\
                || x.user.user_info.firstname.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,"").includes(self.search2.toLowerCase()) || x.user.user_info.firstname.toLowerCase().includes(self.search2.toLowerCase())\
                || x.user.job.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,"").includes(self.search2.toLowerCase()) || x.user.job.toLowerCase().includes(self.search2.toLowerCase())\
                || x.user.email.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,"").includes(self.search2.toLowerCase()) || x.user.email.toLowerCase().includes(self.search2.toLowerCase())\
                || x.type.name.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,"").includes(self.search2.toLowerCase()) || x.type.name.toLowerCase().includes(self.search2.toLowerCase()))

            return data
        toggle_selection_text: ()->
            text = "Selectionner"
            if @checkbox_selection == true
                text = "Fermer"
            if @checkbox_selection == false
                @multipleSelection = []
                @emails = ""
            return text
        toggle_selection_text_group: ()->
            self = @
            text = "Groupes"
            if self.group_selection == true
                text = "Fermer"
            return text
        toggle_selection_icon: ()->
            class_icon = 'mdi-plus-circle-o'
            if @checkbox_selection == true
                class_icon = 'mdi-close-circle-o'
            return class_icon
        toggle_selection_icon_group: ()->
            class_icon = 'mdi-plus-circle-o'
            if @group_selection == true
                class_icon = 'mdi-close-circle-o'
            return class_icon

    methods:
        has_access_right: t.has_access_right

        handle_size_change: (val)->
            @page_size = val

        handle_current_change: (val)->
            @current_page = val
        tableswitch: ()->
            self = @
            self.group_selection = !self.group_selection
            if self.group_selection == false
                self.table1 = true
                self.table2 = false
            if self.group_selection == true
                self.table1 = false
                self.table2 = true

        singlegroup_table: (item)->
            self = @
            self.singlegroup = item
            self.single_table_group = true
            self.table2 = false
        objectSpanMethod: ({row,column,rowIndex,columnIndex})->
            if columnIndex == 0
                if rowIndex % 3 == 0
                    rowspan: 3,
                    colspan: 1
                else
                    rowspan: 0,
                    colspan: 0
        listen_sort: ({ column, prop, order })->
            # console.log "LISTEN", column, prop, order
            self = @
            if prop in ['user_info.lastname', 'user_info.firstname', 'user_info.phone']
                prop_array = prop.split('.')
                @app_users.sort (a,b)->
                    modifier = 1
                    if order == 'descending'
                        modifier = -1
                    return a[prop_array[0]][prop_array[1]].toLowerCase().localeCompare(b[prop_array[0]][prop_array[1]].toLowerCase())*modifier
            else
                @app_users.sort (a,b)->
                    modifier = 1
                    if order == 'descending'
                        modifier = -1
                    return a[prop].toLowerCase().localeCompare(b[prop].toLowerCase())*modifier
        multipleMail: ()->
            self = @
            if self.multipleSelection.length > 0
                emails = self.multipleSelection.map (x) ->
                    x.email
                self.emails = emails.join(',')

            else
                n.warning("Veuillez sélectionner au moins un collaborateur")
        groupmail: (item)->
            self = @
            annuairegroupe = self.annuairegroupe
            test = annuairegroupe.map (x)->
                if item.uid == x.type.uid
                    x.user.email
            self.emails = test.join(',')

        handleSelectionChange: (selection,row)->
            self = @
            if selection.length > 0
                self.multipleSelection = selection
            else
                self.multipleSelection.splice(0,self.multipleSelection.length)
        edit_user: (user)->
            @$store.commit('set_selected_app_user', {'uid':user.uid, 'lastname':user.user_info.lastname, 'firstname':user.user_info.firstname})
            localStorage.setItem("selected_app_user", JSON.stringify(@$store.state.selected_app_user))
            @$router.push({name:'company_users_informations', params: {uid: user.uid}})
            return
        pick_user_for_groupe: (item)->
            self = @
            self.singlegroup = item
            self.checkbox_selection = true
            self.table1 = false
            self.table2 = false
            self.table3 = true
        add_to_group: ()->
            self = @
            multiplemails = self.multipleSelection
            single_group = self.singlegroup
            if multiplemails.length > 0
                multiplemails.forEach (x) ->
                    self.annuairegroupe_form = {
                        uid: '',
                        user_uid: x.uid,
                        type_uid: single_group.uid,
                    }
                    self.save_annuairegroupe(self.annuairegroupe_form)
                n.success()
            else
                n.warning("Veuillez sélectionner au moins un collaborateur")
        remove_multiple_users: ()->
            self = @
            multiplemails = self.multipleSelection
            if multiplemails.length > 0
                self.$confirm("Êtes-vous sûr·e de vouloir supprimer ce type de groupe ?", 'Confirmation', {
                confirmButtonText: 'Oui',
                cancelButtonText: 'Annuler'
                })
                .then ()->
                    multiplemails.forEach (x) ->
                        self.delete_annuaire_groupe_user(x.uid)
                    n.success()
                .catch (cancel)->
                    return
            else
                n.warning("Veuillez sélectionner au moins un collaborateur")
        return_method: ()->
            self = @
            self.checkbox_selection = false
            self.multipleSelection = []
            self.singlegroup = []
            self.single_table_group = false
            self.group_selection = false
            self.emails = ""
            self.table2 = true
            self.table3 = false
        pre_save: ()->
            self = @
            multiplemails = self.multipleSelection
            if self.annuairetypegroupe_form.name != ""
                self.save_annuairetypegroupe(self.annuairetypegroupe_form)
                self.get_annuairegroupe_set
        save_cancel: ()->
            self = @
            self.save_dialog_visible = false
            self.annuairetypegroupe_form = {
                uid: '',
                name: '',
                company_uid:@$store.getters.current_company.uid,
                user_uid:@$store.state.user_datas.app_user.uid
            }
            .self.annuairegroupe_form = {
                uid: '',
                user_uid: '',
                type_uid: '',
            }
        save_annuairetypegroupe: (type)->
            self = @
            m.run('save_annuairetypegroupe',[type])
            .then (resp)->
                if resp.body.data.annuairetypegroupe_form_mutation.form_ret == 'failed'
                    return n.access_denied()
                if resp.body.data.annuairetypegroupe_form_mutation.errors.length > 0
                    self.errors = resp.body.data.annuairetypegroupe_form_mutation.errors.reduce(
                        (acc, el)->
                            acc[el.field] = el.messages
                            return acc
                    ,{})
                else
                    self.errors={}
                    self.loading = true
                    self.save_dialog_visible = false
                    self.annuairetypegroupe_form = {
                        uid: '',
                        name: '',
                        company_uid:self.$store.getters.current_company.uid,
                        user_uid:self.$store.state.user_datas.app_user.uid

                    }
                    self.get_app_users()
                    n.success()
        save_annuairegroupe: (item)->
            self = @
            m.run('save_annuairegroupe',[item])
            .then (resp)->
                if resp.body.data.annuairegroupe_form_mutation.form_ret == 'failed'
                    return n.access_denied()
                if resp.body.data.annuairegroupe_form_mutation.errors.length > 0
                    self.errors = resp.body.data.annuairegroupe_form_mutation.errors.reduce(
                        (acc, el)->
                            acc[el.field] = el.messages
                            return acc
                    ,{})
                else
                    self.errors={}
                    self.save_dialog_visible = false
                    self.annuairegroupe_form = {
                        uid: '',
                        user_uid: '',
                        type_uid:'',
                    }
                    self.loading = true
                    self.table1 = false
                    self.table2 = true
                    self.table3 = false
                    self.checkbox_selection = false
                    self.get_app_users()
                    self.group_selection = false

        delete_annuaire_groupe_user: (item)->
            self = @
            # console.log "ANNUAIRE DELETE", annuaire_groupe_user_uid
            m.run('delete_object',['annuairegroupe',item])
            .then (resp)->
                # console.log "ANNUAIRE EVALUATION", resp.body.data.annuairegroupe_deletion
                if resp.body.data.annuairegroupe_deletion.ok
                    self.loading = true
                    self.get_app_users()
                else
                    n.gql_error("evaluation: delete_evaluation: then", resp.body.data.annuairegroupe_deletion.message)
            .catch (resp)->
                n.catch_error(resp, "evaluation: delete_evaluation()")

        delete_annuaire_type_groupe: (item)->
            self = @
            self.$confirm("Êtes-vous sûr·e de vouloir supprimer ce type de groupe ?", 'Confirmation', {
                confirmButtonText: 'Oui',
                cancelButtonText: 'Annuler'
                })
                .then ()->
                    # console.log "ANNUAIRE DELETE", annuaire_groupe_user_uid
                    m.run('delete_object',['annuairetypegroupe',item])
                    .then (resp)->
                        # console.log "ANNUAIRE EVALUATION", resp.body.data.annuairegroupe_deletion
                        if resp.body.data.annuairetypegroupe_deletion.ok
                            n.success()
                            self.loading = true
                            self.get_app_users()
                        else
                            n.gql_error("evaluation: delete_evaluation: then", resp.body.data.annuairetypegroupe_deletion.message)
                    .catch (resp)->
                        n.catch_error(resp, "evaluation: delete_evaluation()")
                .catch (cancel)->
                    return
    
        get_app_users: ()->
            self = @
            q.run('get_contact_set', [@$store.getters.current_company.uid])
            .then (resp)->
                if resp.body.errors? and resp.body.errors.length > 0
                    for e in resp.body.errors
                        n.gql_error("contact_details: get_app_users: then", e.message)
                else
                    # console.log "GET APP USERS : ", resp.body.data.contact_set
                    self.app_users = resp.body.data.contact_set
                    for u in self.app_users
                        u.job = u.job.substring(1, u.job.length-1)
                    self.loading = false
                    self.get_annuairegroupe_set()
                    self.get_annuairetypegroupe_set()
                    if self.app_users.length == 0
                        self.alert = true
                    else
                        self.alert = false
            .catch (resp)->
                n.catch_error(resp, "contact_details: get_app_users()")
        get_annuairegroupe_set: ()->
            self = @
            q.run('get_annuairegroupe_set', [@$store.getters.current_company.uid])
            .then (resp)->
                if resp.body.errors? and resp.body.errors.length > 0
                    for e in resp.body.errors
                        n.gql_error("contact_details: get_app_users: then", e.message)
                else
                    # console.log "GET ANNUAIRE GROUPES : ", resp.body.data.annuairegroupe_set
                    self.annuairegroupe = resp.body.data.annuairegroupe_set
                    self.loading = false
            .catch (resp)->
                n.catch_error(resp, "contact_details: get_annuairegroupe_set()")
        get_annuairetypegroupe_set: ()->
            self = @
            q.run('get_annuairetypegroupe_set', [@$store.getters.current_company.uid,@$store.state.user_datas.app_user.uid])
            .then (resp)->
                if resp.body.errors? and resp.body.errors.length > 0
                    for e in resp.body.errors
                        n.gql_error("contact_details: get_app_users: then", e.message)
                else
                    # console.log "GET ANNUAIRE TYPE GROUPES : ", resp.body.data.annuairetypegroupe_set
                    self.annuairetypegroupe = resp.body.data.annuairetypegroupe_set.filter (x)-> x.user.uid == self.$store.state.user_datas.app_user.uid
                    self.loading = false

    beforeMount: ()->
        @get_app_users()
}
